import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import AllPackagesPage from './All';
import PackagePage from './Package';

const Packages = () => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={[`${match.url}/all`, `${match.url}/filter`]}>
        <AllPackagesPage />
      </Route>
      <Route exact path={`${match.url}/all/:packageId`}>
        <PackagePage />
      </Route>
    </Switch>
  );
};

export default Packages;
